export const isEmailValid = (v: string) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || "").trim());

// aceita formatos 000.000.000-00 ou só dígitos com 11 chars
export const isCpfFormat = (v: string) => {
  const only = (v || "").replace(/\D/g, "");
  return only.length === 11;
};
